import { RestorationInstructionModalComponent } from './restoration-instruction-modal/restoration-instruction-modal.component';
import { TextAlertComponent } from './text-alert/text-alert.component';
import { CreateUpdateLimitComponent } from './create-update-limit/create-update-limit.component';
import { EditSessionLimitFormComponent } from './edit-session-limit/edit-session-limit.component';
import { LoyaltyBonusModalComponent } from './loyalty-bonus-modal/loyalty-bonus-modal.component';
import { PwaModalComponent } from './pwa-modal/pwa-modal.component';

import { BuyCryptoModalComponent } from './buy-crypto-modal/buy-crypto-modal.component';
import { TournamentPrizeModalComponent } from './tournament-prize-modal/tournament-prize-modal.component';
import { TournamentLeadersModalComponent } from './tournament-leaders-modal/tournament-leaders-modal.component';

export const ModalRegular = {
  TEXT_ALERT: TextAlertComponent,
  RESET_PASS: RestorationInstructionModalComponent,
  LIMIT_FORM: CreateUpdateLimitComponent,
  LIMIT_EDIT_SESSION: EditSessionLimitFormComponent,
  PWA_INSTALL: PwaModalComponent,
  LOYALTY_BONUS: LoyaltyBonusModalComponent,
  BUY_CRYPTO: BuyCryptoModalComponent,
  TOURNAMENT_LEADERS: TournamentLeadersModalComponent,
  TOURNAMENT_PRIZE: TournamentPrizeModalComponent,
};

export type ModalRegularType =
  | 'TEXT_ALERT'
  | 'RESET_PASS'
  | 'DOCUMENTS_FORM'
  | 'LIMIT_EDIT_SESSION'
  | 'LOYALTY_BONUS'
  | 'PWA_INSTALL'
  | 'LIMIT_FORM'
  | 'TOURNAMENT_LEADERS'
  | 'TOURNAMENT_PRIZE'
  | 'BUY_CRYPTO';
